import analytics from 'shared-assets/lib/analytics';

(() => {
  /**
   * @ngdoc directive
   * @name kareo.ui.shared.assets:kProviderUpsellDropdownView
   * @restrict E
   * @scope
   * @description
   * Dropdown that displays a list of providers and providers to upsell in
   * separate sections. Allows users to select a provider and provides
   * callback functions to be called upon selection.
   *
   * @param {array} providers Array of providers to display in the dropdown.
   * @param {array} providersToUpsell Array of providers to display with upsell badge.
   * @param {string} defaultProviderGuid Optional. Guid of selected provider upon initialization.
   * @param {function} onProviderSelected Callback function that is invoked when user selects a provider.
   * Takes in the selected provider as a parameter. Returns true in order to accept the provider selection
   * with the dropdown and false in order to reject the provider selection;
   * @example
    <example module="kareo.ui.shared.directives.k-provider-upsell-dropdown-view">
      <file name="index.html">
        <div class="kareo" ng-controller="KProviderUpsellDropdownDemoCtrl as vm">
          <p>Select Provider:</p>

          <k-provider-upsell-dropdown-view
            providers="vm.providers"
            providers-to-upsell="vm.providersToUpsell"
            default-provider-guid="vm.defaultProviderGuid"
            on-provider-selected="vm.onProviderSelected(provider)">
          </k-provider-upsell-dropdown-view>

          <p>{{ vm.message }}</p>
        </div>
      </file>
      <file name="demo.js">
        angular
          .module('kareo.ui.shared.directives.k-provider-upsell-dropdown-view')
          .controller('KProviderUpsellDropdownDemoCtrl', controller);

        function controller() {
          const vm = this;

          vm.providers = [
            {
              providerGuid: '1',
              firstName: 'John',
              lastName: 'Doe'
            },
            {
              providerGuid: '2',
              firstName: 'Jane',
              lastName: 'Doe'
            }
          ];

          vm.providersToUpsell = [
            {
              providerGuid: '3',
              firstName: 'John',
              lastName: 'Johnson'
            }
          ];

          vm.defaultProviderGuid = '1';
          vm.message = null;

          vm.onProviderSelected = onProviderSelected;

          function onProviderSelected(provider) {
            const isEligibleProvider = provider.lastName === 'Doe';
            const status = isEligibleProvider ? 'Eligible' : 'Ineligible';

            vm.message = status + ' provider (' + provider.firstName + ' ' + provider.lastName + ') selected!';

            return isEligibleProvider;
          }
        }
      </file>
    </example>
   */

  angular
    .module('kareo.ui.shared.directives.k-provider-upsell-dropdown-view', [
      'kareo.ui.shared.directives.user.k-user-profile-image'
    ])
    .component('kProviderUpsellDropdownView', {
      controller,
      controllerAs: 'vm',
      bindings: {
        providers: '<',
        providersToUpsell: '<',
        defaultProviderGuid: '<?',
        onProviderSelected: '&'
      },
      template: require('./k-provider-upsell-dropdown-view.pug')()
    });

  controller.$inject = ['$scope'];

  function controller($scope) {
    const vm = this;

    vm.selectedProvider = null;

    vm.$onInit = init;
    vm.selectProvider = selectProvider;

    $scope.$watch(['vm.providers', 'vm.providersToUpsell'], init);
    $scope.$watch('vm.defaultProviderGuid', init);

    function init() {
      if (!!vm.defaultProviderGuid) {
        const defaultProvider = vm.providers
          .filter((provider) => provider.providerGuid === vm.defaultProviderGuid);

        if (defaultProvider.length === 1) {
          vm.selectProvider(defaultProvider[0]);
        }
      }
    }

    function selectProvider(provider) {
      if (!provider.isMarketingEnabled) {
        analytics.track('Button Clicked', {
          id: 'provider-selection-dropdown.upgrade-cta',
          providerId: provider.providerGuid,
        });
      }

      const isProviderSelectionAccepted = vm.onProviderSelected({ provider });

      if (isProviderSelectionAccepted) {
        vm.selectedProvider = provider;
      }
    }
  }
})();
